import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormReferenceTreeSelect,
  title: 'Reference Tree Select',
  category: ComponentCategory.FormControls,
};
